<app-header-page>
    <app-component-button-header-back href="/account/production/cards">
        Товары
    </app-component-button-header-back>
</app-header-page>

<div class="card-header">
    <span>
        <small><i class="ri-home-4-fill"></i>  *  Маркетплейс  *  Товары  *  Категории</small>
        <h1>
            <app-component-input-inline
                    [value]="card.product_card.title"
                    [editByPen]="true"
                    (emitSave)="editCard('title', $event)"
            ></app-component-input-inline>
<!--            {{ card.product_card.title }}-->
            <mat-chip style="margin-left:16px; background: #fff">
                {{ card.product_card.card_type === 'PRODUCT' ? 'Товар' : 'Услуга' }}
            </mat-chip>
        </h1>
    </span>

    <button mat-raised-button
            [matMenuTriggerFor]="publicCardsButton"
            class="main-buttons small primary"
            #menuTrigger
    >
        <i class="ri-file-4-line"></i> Публичные карточки
    </button>
    <mat-menu #publicCardsButton="matMenu"
              xPosition="before"
              class="backdrop-container"
    >
        <strong>Публичные карточки</strong><br>
        <small>{{ publicCards.length }} карточек</small>

        <div class="backdrop-item-container">
            @for (publicCard of publicCards; track publicCard.puid) {
                <div mat-menu-item
                     (click)="router.navigate(['account', 'production', 'cards', puid, publicCard.puid])"
                >
                    <span>
                        {{ publicCard.title }} <br>
                        <small> {{ publicCard.created_at | date:'HH:mm dd.MM.yyyy' }} </small>
                    </span>
                </div>
            }
        </div>
        <button class="main-buttons block primary"
                (click)="createPublicProductCard()"
        >
            <i class="ri-add-line"></i> Создать карточку
        </button>
        <button class="main-buttons block secondary">
            <i class="ri-close-line"></i> Закрыть
        </button>
    </mat-menu>
</div>

<div class="card-body">
    <div>
        <div style="display: flex;">
            @if (card.photo_first) {
                <div class="position-relative m-1 carousel">
                    @for (photo of card.photos; track photo.ukey) {
                        <div class="carousel_item"
                             [class.current]="photo.ukey === activeBigPhoto.ukey"
                             (mouseover)="activeBigPhoto = photo"
                        >
                            <img style="position: unset;"
                                 [src]="photo.originImage"
                                 alt="#"
                            >
                        </div>
                    }
                </div>
            }
            <div class="position-relative m-2 big-picture">
                @if (activeBigPhoto) {
                    <div class="photo-button previous"
                         (click)="prevPhoto()"
                    >
                        <i class="ri-arrow-left-long-fill"></i>
                    </div>
                    <div class="photo-button next"
                         (click)="nextPhoto()"
                    >
                        <i class="ri-arrow-right-long-fill"></i>
                    </div>
                    <img [src]="activeBigPhoto.originImage"
                         alt="#"
                    >
                } @else {
                    <img ngSrc="../../../../assets/images/placeholders/no_image.jpg"
                         alt="#"
                         height="455"
                         width="455"
                    >
                }

                <button class="photo-button add"
                        (click)="modalService.openTemplateModal(addProductCardPhoto)"
                >
                    <i class="ri-add-circle-fill"></i> Добавить
                </button>
            </div>
        </div>
    </div>
    <div style="width: 100%;">
        <mat-tab-group>
            <mat-tab label="Описание">
                <app-component-ckeditor
                        [inputData]="card.product_card.description"
                        (emitFinish)="editCard('description', $event[1])"
                ></app-component-ckeditor>
            </mat-tab>
            <mat-tab label="Характеристики"> Тут проперти будут</mat-tab>
            <mat-tab label="Документы">
                <button class="btn btn-success mb-3 mt-3"
                        (click)="modalService.openTemplateModal(collectionView, 'xl')"
                >
                    Добавить коллекцию
                </button>

                <mat-accordion [displayMode]="'flat'">
                    @for (collection of card.collections; track collection.id) {
                        <mat-expansion-panel class="accordion-item"
                                             [togglePosition]="'before'"
                                             (opened)="openCollectionAccordion(collection.id)"
                        >
                            <mat-expansion-panel-header
                                    [collapsedHeight]="'48px'"
                                    [expandedHeight]="'48px'"
                            >
                                <mat-panel-title>
                                    {{ collection.name }}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div>
                                <strong>
                                    {{ collection.name }}
                                </strong>
                                <div [innerHTML]="collection.description"></div>

                                <div style="margin: 15px 0;">
                                    <app-component-folder-and-file-table
                                            (eventFind)="onEventFind($event)"
                                            (eventClick)="onEventClick($event, viewDocument)"
                                            [$mediator]="controller.$mediator"

                                            [isNeedRefreshMediator]="true"
                                            [showBackButton]="false"
                                    ></app-component-folder-and-file-table>
                                </div>

                                <button class="btn btn-danger"
                                        (click)="removeCollection(collection.id)"
                                >
                                    <lucide-icon class="me-1"
                                                 size="16"
                                                 name="trash-2"
                                                 [strokeWidth]="1.2"
                                    ></lucide-icon>
                                    <span>Удалить</span>
                                </button>
                            </div>
                        </mat-expansion-panel>
                    }
                </mat-accordion>
            </mat-tab>
            <mat-tab label="Комментарии"> Тут комменты</mat-tab>
        </mat-tab-group>
    </div>
</div>

<ng-template #addProductCardPhoto
             let-modal
>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h2>Фотография</h2>
        <input type="file"
               class="form-control"
               id="customFile"
               multiple
               accept="image/*"
               (change)="viewImageUpload($event)"
               #files
        >


        <div class="img-table">
            <div class="img-card"
                 *ngFor="let preview of previews; let i = index"
            >
                <img class="preview-image"
                     [src]="preview"
                     (click)="removeImage(files, i)"
                     alt="#">
                <!--                <img class="hover-image" src="../../../../assets/images/icons/x-square.svg" alt="#">-->
            </div>
        </div>

        <button class="btn btn-success mt-2"
                (click)="addNewPhotos(modal)"
        >
            Сохранить
        </button>
    </div>
</ng-template>

<ng-template #collectionView
             let-modal>
    <app-button-modal-close [modalSize]="'xl'"
                            [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <app-component-file-navigator
                (eventSelected)="selectCollection($event[0])"
                (eventSubmit)="addCollection(modal)"
                selectedType="collection"
        ></app-component-file-navigator>
    </div>
</ng-template>

<ng-template #viewDocument
             let-modal
>
    <app-button-modal-close (closeEmit)="documentKey = ''"
                            [modal]="modal"
                            modalSize="xl"
    ></app-button-modal-close>
    <div class="modal-body">
        <app-component-doc-view
                [fileUkey]="documentKey"
        ></app-component-doc-view>
    </div>
</ng-template>

<ng-template #cardClonerModal>
    <mat-dialog-content>
        <h2>Создать публичную карточку</h2>
        <mat-stepper [linear]="true"
                     #stepper
        >
            <mat-step [stepControl]="photoCheckForm">
                <form [formGroup]="photoCheckForm">
                    <ng-template matStepLabel>Общее</ng-template>
                    <div>
                        <h2>Название:</h2>
                        <input type="text"
                               [value]="card.product_card.title"
                        >

                        <h2>Описание</h2>
                        <span>..Тут редактор описания позже..</span>
                    </div>
                    <div>
                        <button mat-button
                                matStepperNext
                        >
                            Далее
                        </button>
                    </div>
                </form>
            </mat-step>
            <mat-step [stepControl]="photoCheckForm">
                <form [formGroup]="photoCheckForm">
                    <ng-template matStepLabel>Изображения</ng-template>
                    <div class="form-photo-inputs-content">
                        @for (photoControl of photosFormArray.controls; track i; let i = $index) {
                            <div formArrayName="photos"
                                 class="container">
                                <label class="input-photo"
                                       [for]="card.photos[i].ukey"
                                >
                                    <img class="minimized-image"
                                         [src]="card.photos[i].originImage"
                                         alt="#"
                                    >
                                </label>
                                <input type="checkbox"
                                       [id]="card.photos[i].ukey"
                                       [formControlName]="i"
                                       class="checkbox"
                                >
                            </div>
                        }
                    </div>
                    <div>
                        <button mat-button
                                matStepperPrevious
                        >
                            Назад
                        </button>
                        <button mat-button
                                matStepperNext
                        >
                            Далее
                        </button>
                    </div>
                </form>
            </mat-step>
            <mat-step [stepControl]="secondFormGroup">
                <form [formGroup]="secondFormGroup">
                    <ng-template matStepLabel>Документы</ng-template>
                    <mat-form-field>
                        <mat-label>Address</mat-label>
                        <input matInput
                               formControlName="secondCtrl"
                               placeholder="Ex. 1 Main St, New York, NY"
                               required
                        >
                    </mat-form-field>
                    <div>
                        <button mat-button
                                matStepperPrevious
                        >
                            Назад
                        </button>
                        <button mat-button
                                matStepperNext
                        >
                            Далее
                        </button>
                    </div>
                </form>
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>Проперти (возможные)</ng-template>
                <p>You are now done.</p>
                <div>
                    <button mat-button
                            matStepperPrevious
                    >
                        Назад
                    </button>
                    <button mat-button
                            (click)="stepper.reset()"
                    >
                        Создать
                    </button>
                </div>
            </mat-step>
        </mat-stepper>
    </mat-dialog-content>
</ng-template>
